(function(){
  
  let addon_block = document.querySelector('.add-on-wrapper');
  
  document.addEventListener("DOMContentLoaded", e=>{
    if(!addon_block){
      return false;
    }

    //Popup work
    let popup = addon_block.querySelector('.add-on-popup-wrapper');
    addon_block.querySelector('.learn-more')?.addEventListener('click',(e)=>{
      e.preventDefault();
      document.querySelector('html').classList.toggle('add-on-popup-active');
    });

    document.querySelector('.add-on-popup-wrapper').addEventListener('click', e=>{
        if(e.target.classList.contains('add-on-popup-wrapper')){
          document.querySelector('html').classList.toggle('add-on-popup-active');
        }
    })
    

    popup?.querySelectorAll('.close').forEach(close_item=>{
      close_item.addEventListener('click', ()=>{
        document.querySelector('html').classList.remove('add-on-popup-active');
      })
    })

    
    //Cart Element Object
    let cart_object;
    if(addon_data_template_name == 'product'){
      cart_object = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }
    if(addon_data_template_name == 'cart'){
      cart_object = document.querySelector('cart-items')
    }



    /* Add-on Work */
    addon_block.querySelector('.add-to-cart').addEventListener('click', function(){

      //Prevent Double-Click
      let _this = this;
      if(this.classList.contains('processing')){
        return false;
      }
      this.classList.add('processing');


      addon_data.sections = cart_object.getSectionsToRender().map((section) =>{
        if(addon_data_template_name == 'cart'){
          return section.section
        }
        if(addon_data_template_name == 'product'){
          return section.id;
        }
      });

      
      addon_data.sections_url = window.location.pathname;
      if(addon_data_template_name == 'product'){
        cart_object.setActiveElement(document.activeElement);
      }


      fetch('/cart/add.js',{
        method:"POST",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body:JSON.stringify(addon_data)
      })
      .then((response) => response.json())
      .then(response=>{

        addon_block.classList.remove('active');


        if(addon_data_template_name == 'cart'){
          cart_object.fullCartUpdate(response.sections);
        }

        if(addon_data_template_name == 'product'){
          cart_object.classList.remove('is-empty');
          cart_object.renderContents(response);
        }


        let cartUpdateEvent = new CustomEvent('cart-updated',{
          detail: response
        });
        document.dispatchEvent(cartUpdateEvent);


        _this.classList.remove('processing');
    
      });
      
    });


    document.addEventListener('cart-updated',(e)=>{
      //Show Upsell Block if user deleted the upsell product from the cart
      let upsell_product_in_cart = e.detail.items;
      if(upsell_product_in_cart){
        upsell_product_in_cart.some(item=>{
          return item.id == addon_data.id
        });
      }
      if(!upsell_product_in_cart){
        addon_block.classList.add('active');
      }
      location.reload();
    });


    let addon_block_discount = addon_block.querySelector('.upsell-value-discount-amount .discount-value');
    if(addon_block_discount){
      document.addEventListener("la:dn:cart:updated", function(event){
        let new_subtotal = ((event.detail.data[0].subtotal.discountedPrice/10000) * addon_data_discount).toFixed(2);
        new_subtotal = discountNinjaContext.MoneyFormat.replace("{{amount}}", new_subtotal);
        addon_block_discount.innerHTML = new_subtotal;
      });   
    }


  })
})();